import { reversePincodeData } from './reversePincodeData';

/**
 * Format district name to proper case
 * @param {string} districtName - District name to format
 * @returns {string} Formatted district name
 */
export const formatDistrictName = (districtName) => {
  if (!districtName) return '';
  
  return districtName
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Get formatted location string from patient details
 * @param {Object} patientDetails - Patient details object
 * @returns {string} Formatted location (village, district) or empty string
 */
export const getFormattedLocation = (patientDetails) => {
  if (!patientDetails) return '';
  
  const village = patientDetails.village || '';
  
  if (patientDetails.home_pincode && 
      reversePincodeData[patientDetails.home_pincode]) {
    const rawDistrict = reversePincodeData[patientDetails.home_pincode].district;
    const formattedDistrict = formatDistrictName(rawDistrict);
    return village === '' ? `${formattedDistrict}` : `${village}, ${formattedDistrict}`;
  }
  
  // Return just the village if no district data
  return village;
};

